import React, { ComponentPropsWithoutRef } from 'react';
import FeaturedPost from './FeaturedPost';
import classnames from 'classnames';
import { useGetFeaturedPostsQuery } from '../../../../../../../store/api-slices';
import { useSelector } from 'react-redux';
import { selectFranchiseId } from '../../../../../../../store/slices/InitialDataSlice';
import { useTranslation } from 'react-i18next';

const FeaturedPosts = ({ className, ...rest }: ComponentPropsWithoutRef<'section'>) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Home:Components:FeaturedPosts' });

  const franchiseId = useSelector(selectFranchiseId);
  const { data } = useGetFeaturedPostsQuery(
    {
      franchiseId,
    },
    { skip: !franchiseId },
  );

  if (!data?.length) {
    return;
  }

  return (
    <section className={classnames('space-y-md', className)} {...rest}>
      <h2 className="font-semibold text-md">{t('title')}</h2>
      {data?.map((post) => (
        <FeaturedPost key={post.id} post={post} />
      ))}
    </section>
  );
};

export default FeaturedPosts;
